import { apiBaseUrl } from "./config";
import { sendGetRequest, sendPost, setUtilsToken } from "./utils";

const baseUrl = `${apiBaseUrl}/orders`;
let token;

function setOrdersToken(t) {
  token = t;
  setUtilsToken(t);
}

async function submitMembershipOrder(paypalOrderId, paypalConfirmation, lineItems, membership) {
  const url = `${baseUrl}/registro`;

  let body = {
    paypalOrderId,
    paypalConfirmation,
    lineItems,
    membership
  }

  const r = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await r.json();
  if (!r.ok) {
    throw data;
  }
  return data;
}

async function submitMaterialOrder(thirdPartyOrderId, confirmationNumber, lineItems, membership, paid, orderId) {
  const url = `${baseUrl}/material`;

  let body = {
    thirdPartyOrderId,
    confirmationNumber,
    lineItems,
    membership,
    paid,
    orderId
  }

  const r = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await r.json();
  if (!r.ok) {
    throw data;
  }
  return data;
}

async function manuallyRegisterMembershipPayment(token, membership, comments) {
  const url = `${baseUrl}/registro/manual`;

  let body = {
    membership,
    comments
  }

  const r = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await r.json();
  if (!r.ok) {
    throw data;
  }
  return data;
}

function fetchClientSecret(membership, email) {
  
  const payload = {
    membership,
    email,
  };
  return async function() {
    const url = `${baseUrl}/registro/create-checkout-session`;
    let r = await sendPost(null, url, payload);
    return r.clientSecret;
  }
}

function fetchStripeSessionSecret(lineItems, email, setSession, membership, setOrder, orderId) {
  const payload = { lineItems, email, membership, orderId };
  return async function() {
    const url = `${baseUrl}/material/create-checkout-session`;
    let r = await sendPost(null, url, payload);
    if (setSession && typeof setSession === 'function') {
      setSession(r.clientSecret);
    }
    if (setOrder && typeof setOrder === 'function') {
      setOrder(r.order);
    }
    return r.clientSecret;
  }
}

async function getComunidadOrderHistory(comunidadId, orderType) {
  let url = `${baseUrl}/comunidad/${comunidadId}`;
  if (orderType) {
    url += `?orderType=${orderType}`;
  }
  return await sendGetRequest(url);
}

async function getDiocesisOrderHistory(diocesisId, orderType) {
  let url = `${baseUrl}/diocesis/${diocesisId}`;
  if (orderType) {
    url += `?orderType=${orderType}`;
  }
  return await sendGetRequest(url);
}

async function getRegionOrderHistory(regionId, orderType) {
  let url = `${baseUrl}/region/${regionId}`;
  if (orderType) {
    url += `?orderType=${orderType}`;
  }
  return await sendGetRequest(url);
}

async function getOrders(filters = {}) {
  let url = baseUrl;
  if (filters && Object.keys(filters).length) {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') {
        params.append(k, v);
      }
    });
    const qs = params.toString();
    if (qs) url += '?' + qs;
  }
  return await sendGetRequest(url);
}

async function updateOrderDeliveryStatus(orderId, status) {
  let url = `${baseUrl}/${orderId}`;
  return await sendPost(token, url, { deliveryStatus: status });
}

async function getOrderReceiptUrl(orderId) {
  const url = `${baseUrl}/${orderId}/receipt`;
  return await sendGetRequest(url);
}

export {
  setOrdersToken,
  submitMembershipOrder,
  manuallyRegisterMembershipPayment,
  fetchClientSecret,
  fetchStripeSessionSecret,
  submitMaterialOrder,
  getComunidadOrderHistory,
  getDiocesisOrderHistory,
  getRegionOrderHistory,
  getOrders,
  updateOrderDeliveryStatus,
  getOrderReceiptUrl
};
